import React, { memo, useMemo } from "react";
import { FaThumbsUp } from "react-icons/fa";
import ModalPopup from "@components/Common/ModalPopup";
import ProfileImage from "./ProfileImage";
import ProfileDetails from "./ProfileDetails";
import { useProfileImage, useProfileData } from "../hooks";
import img from "@assets/Images/profile11.png";
import styles from "@components/Common/Profile.module.css";

/**
 * Profile component - Main user profile view
 * Optimized with custom hooks, memoization, and sub-components
 */
const Profile = () => {
  const { userDetails, profileType, mobileNumber, hasPhoto } = useProfileData();
  
  const {
    imgCrop,
    storeImage,
    isModalOpen,
    isSuccess,
    successMessage,
    validationError,
    setIsSuccess,
    handleCrop,
    handleClose,
    handleBeforeFileLoad,
    handleSaveImage,
    handleRemoveImage,
    handleOpenModal,
  } = useProfileImage(userDetails);

  // Memoize image URL
  const displayImageUrl = useMemo(() => {
    if (hasPhoto && storeImage) {
      return `data:image/png;base64,${storeImage}`;
    }
    return null;
  }, [hasPhoto, storeImage]);

  return (
    <div className={styles.profile_OuterBox}>
      <div className="container">
        <div className="row d-flex justify-content-center align-items-center">
          <div className={styles.profile_name}>{userDetails?.Name}</div>
          
          <ProfileImage
            imageUrl={displayImageUrl}
            defaultImage={img}
            imgCrop={imgCrop}
            isModalOpen={isModalOpen}
            validationError={validationError}
            onOpenModal={handleOpenModal}
            onCloseModal={handleClose}
            onCrop={handleCrop}
            onBeforeFileLoad={handleBeforeFileLoad}
            onSaveImage={handleSaveImage}
            onRemoveImage={handleRemoveImage}
          />

          <ProfileDetails
            mobileNumber={mobileNumber}
            email={userDetails?.Email}
            profileType={profileType}
          />
        </div>

        {isSuccess && (
          <ModalPopup
            className=""
            isModalOpen={isSuccess}
            setIsModalOpen={setIsSuccess}
            title={successMessage}
            backdrop={true}
            fade={false}
            icon={
              <div className="submittedIcons draftIcons">
                <FaThumbsUp className="submittedSmall" />
                <FaThumbsUp className="submittedLarge" />
                <FaThumbsUp className="submittedSmall" />
              </div>
            }
          />
        )}
      </div>
    </div>
  );
};

export default memo(Profile);
